import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { FormattedMessage } from 'react-intl';

import { trackAction } from 'app/shared/utils/tracking';
import {
  GridContainerSt,
  GridRowSt,
} from 'app/dealer/shared/components/Grid/Grid.css';

import { FooterListColSt, FooterSt, FooterCopySt } from './Footer.css';

// using purposefully verbose tracking funtions so they can be documented
// via our `yarn extractTrackActions` script
export const Footer = ({ target, reference, isLoggedIn }) => {
  const memoizedTrackFaq = useCallback(() => {
    trackAction('dealer_faq_footer_click', {
      category: `${target}`,
      description: 'user clicks on dealer faq on footer',
    });
  }, [target]);

  const memoizedTrackCareers = useCallback(() => {
    trackAction('careers_footer_click', {
      category: `${target}`,
      description: 'user clicks on careers text on footer',
    });
  }, [target]);

  const memoizedTrackPress = useCallback(() => {
    trackAction('press_footer_click', {
      category: `${target}`,
      description: 'user clicks on press text on footer',
    });
  }, [target]);

  const memoizedTrackRequestInvite = useCallback(() => {
    trackAction('dealer_request_invite_footer_click', {
      category: `${target}`,
      description: 'user clicks on dealer request_invite text on footer',
    });
  }, [target]);

  const memoizedTrackCookieDashboard = useCallback(() => {
    trackAction('cookie_dashboard_footer_click', {
      category: `${target}`,
      description: 'user clicks on cookie dashboard text on footer',
    });
  }, [target]);

  const memoizedTrackPrivacy = useCallback(() => {
    trackAction('privacy_footer_click', {
      category: `${target}`,
      description: 'user clicks on privacy text on footer',
    });
  }, [target]);

  const memoizedTrackImprint = useCallback(() => {
    trackAction('imprint_footer_click', {
      category: `${target}`,
      description: 'user clicks on imprint text on footer',
    });
  }, [target]);

  const memoizedTrackContact = useCallback(() => {
    trackAction('contact_footer_click', {
      category: `${target}`,
      description: 'user clicks on contact text on footer',
    });
  }, [target]);
  return (
    <FooterSt ref={reference}>
      <GridContainerSt>
        <GridRowSt>
          <FooterListColSt sm={12} md={4}>
            {isLoggedIn && (
              <Link to="/dealer/service/faq" onClick={memoizedTrackFaq}>
                <FormattedMessage
                  id="app.navigation.dealerFaq"
                  defaultMessage="Händler-FAQ"
                />
              </Link>
            )}
            <a href="https://hey.car/careers" onClick={memoizedTrackCareers}>
              <FormattedMessage
                id="app.navigation.career"
                defaultMessage="Karriere"
              />
            </a>
            <a href="https://hey.car/press" onClick={memoizedTrackPress}>
              <FormattedMessage
                id="app.navigation.press"
                defaultMessage="Presse"
              />
            </a>
            <Link
              to="/dealer/request-invite"
              onClick={memoizedTrackRequestInvite}
            >
              <FormattedMessage
                id="app.navigation.requestInvite"
                defaultMessage="Händlerregistrierung"
              />
            </Link>
          </FooterListColSt>
          <FooterListColSt sm={12} md={4}>
            <a
              href="/cookie-dashboard"
              onClick={memoizedTrackCookieDashboard}
            >
              <FormattedMessage
                id="app.navigation.cookieDashboard"
                defaultMessage="Cookie Dashboard"
              />
            </a>

            <a href="https://hey.car/privacy" onClick={memoizedTrackPrivacy}>
              <FormattedMessage
                id="app.navigation.privacy"
                defaultMessage="Datenschutz"
              />
            </a>

            <a href="https://hey.car/imprint" onClick={memoizedTrackImprint}>
              <FormattedMessage
                id="app.navigation.imprint"
                defaultMessage="Impressum"
              />
            </a>

            <a href="https://hey.car/contact" onClick={memoizedTrackContact}>
              <FormattedMessage
                id="app.navigation.contact"
                defaultMessage="Kontakt"
              />
            </a>
          </FooterListColSt>
        </GridRowSt>

        <GridRowSt>
          <FooterCopySt sm={12}>
            &copy;
            {` Copyright ${new Date().getFullYear()} `}
            <FormattedMessage
              id="shared.components.Footer.copy"
              defaultMessage="Mobility Trader GmbH. Alle Rechte vorbehalten."
            />
          </FooterCopySt>
        </GridRowSt>
      </GridContainerSt>
    </FooterSt>
  );
};

Footer.propTypes = {
  target: PropTypes.string.isRequired,
  reference: PropTypes.func,
  isLoggedIn: PropTypes.bool,
};

Footer.defaultProps = {
  reference: null,
  isLoggedIn: false,
};
